/* eslint-disable react/jsx-no-constructed-context-values */
import { createContext, useState } from 'react';

const notificationContext = createContext();

export default notificationContext;
